"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SecondaryControls_styles_1 = __importDefault(require("./SecondaryControls.styles"));
var AGPagination_1 = __importDefault(require("../../molecules/AGPagination/AGPagination"));
var AGHitsPerPage_1 = __importDefault(require("../../molecules/AGHitsPerPage/AGHitsPerPage"));
var SecondaryControls = function () { return (react_1.default.createElement(SecondaryControls_styles_1.default, null,
    react_1.default.createElement(AGHitsPerPage_1.default, { defaultRefinement: 20, items: [
            { value: 20, label: '20' },
            { value: 50, label: '50' },
            { value: 100, label: '100' },
        ] }),
    react_1.default.createElement(AGPagination_1.default, null))); };
exports.default = SecondaryControls;
